import { render, staticRenderFns } from "./marquee-text.vue?vue&type=template&id=37954303"
import script from "./marquee-text.vue?vue&type=script&lang=ts"
export * from "./marquee-text.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports